$(document).ready(function () {
    function scrollTo(element, speed) {
      $([document.documentElement, document.body]).animate({
          scrollTop: $(element).offset().top
      }, speed);
    }

    var maxHeight = $(window).height() - $('#shopify-section-header').height() - 20;
    $('.AccountMain').css('min-height', maxHeight + 'px');



  if($('body').hasClass('customers-account-edit')) {
      var checkExist = setInterval(function() {
          if ($('.cf-form-actions').length) {
              clearInterval(checkExist);
              $('.cf-form-actions').append('<button type="button" class="btn button btn-cancel">Annuler</button>');
          }
      }, 100);

      $(document).on('click','.cf-form-actions .btn-cancel',function(e) {
          e.preventDefault();
          window.location.href = "/account";
      });
  }
  if($('body').hasClass('customers-addresses')) {

    $('[type="submit"]').on('click', function () {
        $(this).closest('form').addClass('submited');
    });
    $('.AddressEditList form [required], #address_form_new [required]').blur(function() {
      if(!$.trim($(this).val())) {
          $(this).addClass('invalid');
      } else {
          $(this).removeClass('invalid');
      }
    });

    $('.Address .AddressActions__Edit a').on('click', function (cpt) {
      if($('.AddressNew').is(":visible")) {
        $('.AddressNew').hide();
      }
      if ($('.Address .AddressActions__Edit a.active').length == 0) {
        $('.Address--Add').hide();
        $(this).addClass('active');
        $('.Address').not('#' + $(this).parents('.Address').attr('id')).removeClass('enable');
        scrollTo('.AddressEditList', 600);
      } else {
        if($(this).hasClass('active')) {
          if ($('.Address .AddressActions__Edit a.active').length == 1) {
            // C'est le mien, donc là je le ferme
            $('.Address--Add').show();
            $(this).removeClass('active');
            $('.Address').not('.enable').addClass('enable');
          } else {
            $(this).removeClass('active');
          }
        } else {
          $(this).addClass('active');
          $('.Address').not('#' + $(this).parents('.Address').attr('id')).removeClass('enable');
        }
      }
    });
    $('.edit_address .note a').on('click', function () {
        $('#address_' + $(this).data('form') + ' .AddressActions__Edit a').removeClass('active');
        if ($('.Address .AddressActions__Edit a.active').length == 0) {
          $('.Address--Add').show();
          $('.Address').not('.enable').addClass('enable');
        }
    });
    $('.Address--Add a').on('click', function () {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active');
          $('.Address').not('.enable').addClass('enable');
        } else {
          $(this).addClass('active');
          $('.Address').removeClass('enable');
          scrollTo('#add_address', 600);
        }
    });


  }
});